import { render } from "./GalidanciaHomeLogo.vue?vue&type=template&id=1982f6fb&scoped=true&ts=true"
import script from "./GalidanciaHomeLogo.vue?vue&type=script&lang=ts"
export * from "./GalidanciaHomeLogo.vue?vue&type=script&lang=ts"

import "./GalidanciaHomeLogo.vue?vue&type=style&index=0&id=1982f6fb&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1982f6fb"]])

export default __exports__